import Type from './Type';
export function isIImage(node) {
    return node.type === Type.Image;
}
export default isIImage;    //# sourceMappingURL=isIImage.js.map
